import React, { Component } from 'react'
import { Chart } from "react-google-charts"
import { connect } from 'react-redux'
import { Icon, Row, Col, Button } from 'react-materialize'
import domtoimage from 'dom-to-image'
import countryRegion from '../data/countryRegion'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import $ from 'jquery';


class MapView extends Component {
  state={
    tooltip: null,
    mapSize: null,
  }

  componentWillMount(){
    this.setState({ mapSize: 1.5 }, ()=>{
      document.getElementById("scroll-map").scrollTop += 100;
      document.getElementById("scroll-map").scrollLeft += 300;
    })
  }

  downloadJPG(){
    var node = document.getElementById('map-view').cloneNode(true);
    console.log(node);
    var combined = document.createElement('img');

    combined.alt = "logo"
    combined.src="logo.png";
    combined.height = "43";
    combined.width = "179"
    node.prepend(combined);
    console.log(node);

    domtoimage.toJpeg(node, { bgcolor: "white", height: 700, width: 1100 })
     .then(function (dataUrl) {
         var link = document.createElement('a');
         link.download = 'map-view.jpeg';
         link.href = dataUrl;
         link.click();
     });
  }

  increaseMap(){
    //var position = document.getElementById('scroll-map').scrollWidth;
    // mapSize = mapSize <= 5 ? mapSize += 1: mapSize
    var mapSize = this.state.mapSize
    if(mapSize === 1){
      this.setState({ mapSize: 1.5 }, ()=>{
        document.getElementById("scroll-map").scrollTop += 100;
        document.getElementById("scroll-map").scrollLeft += 300;
      })
    } else if(mapSize <=6){
      mapSize += 1
      this.setState({ mapSize }, ()=>{
        document.getElementById("scroll-map").scrollTop += 200;
        document.getElementById("scroll-map").scrollLeft += 400;
      })
    }
  }

  decreaseMap(){
    //var position = document.getElementById('scroll-map').scrollHeight;
    var mapSize = this.state.mapSize
    //mapSize = mapSize > 1 ? mapSize -= 1: mapSize
    if(mapSize > 1.5){
      mapSize -= 1
      this.setState({ mapSize }, () =>{
        document.getElementById("scroll-map").scrollTop -= 200;
        document.getElementById("scroll-map").scrollLeft -= 400;
      })
    } else {
      this.setState({ mapSize: 1 })
    }
  }

  panLeftMap(){
    document.getElementById("scroll-map").scrollLeft -= 50;
  }

  panRightMap(){
    document.getElementById("scroll-map").scrollLeft += 50;
  }

  panUpMap(){
    document.getElementById("scroll-map").scrollTop -= 50;
  }

  panDownMap(){
    document.getElementById("scroll-map").scrollTop += 50;
  }

  render() {
   var options = {
     //colorAxis: {colors: ['#d7f3f4','#003864']}, second
     //originally
     //colorAxis: {colors: ['#67d1d3','#003864']},
     //colorAxis: {colors: ['#7DCEA0','#003864']},
     colorAxis: {colors: ['#BCEBED','#003864']},
     legend:  {textStyle: {color: 'blue', fontSize: 16}},
     style: { border: "solid yellow"},
     mode: 'region',
     enableRegionInteractivity: true,
     // chartArea: {width: '1000%', height: '90%'},
     tooltip:
     {  textStyle: {
          color: 'black',
          fontSize: 12,
          whiteSpace: 'pre-wrap'
        },
        showColorCode: true,
        isHtml: true,
        trigger: 'focus'
      }
   };

   var { data, gender, toggleGender, yearBound, age, countries, allCountries, sortedAgeByData, displayMessage = ()  => {} } = this.props;
   var map_data = [["Country", "Value", {role: 'tooltip'}]];
   var latest_year_country = {}

    data.forEach ( data => {
      if( age.includes(data.age) && gender.includes(data.gender) && data.sample_year <= yearBound[1] && data.sample_year >= yearBound[0]){
        if( latest_year_country.hasOwnProperty(data.country)){
          if(latest_year_country[data.country] < data.sample_year){
            latest_year_country[data.country] = data.sample_year
          }
        } else {
          latest_year_country[data.country] = data.sample_year
        }
      }
    });

  if(gender.length === 1 && sortedAgeByData.length === 1 && ( allCountries.length === countries.length || countries.length <= 10)){
    data.forEach( data => {
      if(data.gender === gender[0] &&
         data.sample_year == latest_year_country[data.country] &&
         data.age == sortedAgeByData[0] &&
         countries.includes(data.country)){
           map_data.push([ data.country,
                           parseFloat(data.value),
                           `VALUE: ${parseFloat(data.value)}
                            YEAR: ${data.sample_year}
                            GENDER: ${data.gender}
                            AGE: ${data.age}` ])
         }
       })
     }

  map_data.forEach( data => {
    if(data[0].includes('Hong Kong')){
      data[0] = 'Hong Kong'
    } else if( data[0].includes('mainland')){
      data[0] = 'China'
    } else if ( data[0].includes('Macau')){
      data[0] = 'Macao'
    }
  })

  return (
    <div>
      <div style={{ display:'flex' }}>
        <div id="scroll-map"
                style={{
                      width: '93%',
                      position: "relative",
                      overflow: 'scroll'}}>
          <div className="country-tooltip"/>
          <div id="map-view" className="map-view"
              style={{transform: `scaleX(${this.state.mapSize}) scaleY(${this.state.mapSize})`, transformOrigin: '0 0'}}>
          {

            <Chart
              chartEvents={[
                {
                  eventName: "ready",
                  callback: (chartWrapper)=> {
                    var rthis = this
                    document.addEventListener( "mouseover", function(e){
                      var container = document.querySelector(`#reactgooglegraph-${rthis.props.clickTimes}> div:last-child`)
                      if(container){
                        var tooltip = container.querySelector('.google-visualization-tooltip')

                        if(tooltip){
                          console.log(tooltip);
                          var left = parseFloat(e.layerX) - 130 < 0? 0: parseFloat(e.layerX) - 130
                          var top = parseFloat(e.layerY) + 15
                          left = `${left}px`
                          top = `${top}px`
                          document.querySelector('.country-tooltip').innerHTML = tooltip.innerHTML
                          document.querySelector('.country-tooltip').setAttribute("style",
                          `left:${left};
                          top: ${top};
                          display: block;
                          `)
                        } else {
                          document.querySelector('.country-tooltip').setAttribute("style",
                          `
                          display: none;`)
                        }
                      }

                      function click(x,y){
                        var ev = document.createEvent("MouseEvent");
                        var el = document.elementFromPoint(x,y);
                        ev.initMouseEvent(
                          "click",
                          true /* bubble */, true /* cancelable */,
                          window, null,
                          x, y, 0, 0, /* coordinates */
                          false, false, false, false, /* modifier keys */
                          0 /*left*/, null
                        );
                        if(ev && el){
                          el.dispatchEvent(ev);
                        }
                      }
                    })
                  }
                    },
                    {
                      eventName: "select",
                      callback: (chartWrapper, a , e ) => {
                        const chart = chartWrapper.getChart();
                        const selection = chart.getSelection();
                        if (selection.length === 0) return;
                        const content = map_data[selection[0].row + 1];
                        var val = content[0] + "\n" + content[2]
                        this.setState({ tooltip: val })
                      }
                    }
                  ]}
                  chartType="GeoChart"
                  enableRegionInteractivity={true}
                  width="100%"
                  height="500px"
                  options= {options}
                  data={map_data} />
          }
          </div>
        </div>
        <div style={{display:'flex', alignItems: "center", flexDirection: 'column', width: '7%'}}>
          <span onClick={()=> this.increaseMap()} style={{marginTop: '5px', marginBottom: '10px'}}>
            <Icon>zoom_in</Icon>
          </span>
          <span onClick={()=> this.decreaseMap()} style={{marginTop: '5px', marginBottom: '10px'}}>
            <Icon>zoom_out</Icon>
          </span>
          <span style={{display:'flex', alignItems:'flex-end'}} onClick={()=> this.panUpMap()}>
            <Icon>keyboard_arrow_up</Icon>
          </span>
          <div style={{display: 'flex', justifyContent: 'space-between', width: '80px'}}>
            <span style={{ marginRight:"5%" }} onClick={()=> this.panLeftMap()}>
              <Icon>keyboard_arrow_left</Icon>
            </span>
            <span onClick={()=> this.panRightMap()}>
              <Icon>keyboard_arrow_right</Icon>
            </span>
          </div>
          <span style={{display:'flex', alignItems:'flex-start'}} onClick={()=> this.panDownMap()}>
            <Icon>keyboard_arrow_down</Icon>
          </span>
        </div>
      </div>
      <div className="pulled-right">
        <Button onClick={()=> this.downloadJPG()}>DOWNLOAD JPG</Button>
      </div>
    </div>
  )}
}

function mapStateToProps(state){
  return {
    data: state.data,
    gender: state.gender,
    yearBound: state.yearBound,
    countries: state.countries,
    age: state.age,
    toggleGender: state.toggleGender,
    sortedAgeByData: state.sortedAgeByData,
    allCountries: state.allCountries
  }
};

function mapDispatchToProps(dispatch){
  return {
    selectGender: (gender) => dispatch({ type: 'TOGGLEGENDER', value: gender }),
  }
}



export default connect(mapStateToProps, mapDispatchToProps)(MapView);




// document.addEventListener( "mouseover", function(e){
//   console.log('lol');
//   var container = document.querySelector('#reactgooglegraph-1> div:last-child');
//   var tooltip = container.querySelector('.google-visualization-tooltip');
//   console.log(tooltip);
//   if(tooltip){
//        var top = parseFloat(tooltip.style.top)/2
//        var left = parseFloat(tooltip.style.left)/2
//        tooltip.setAttribute("style", `left:${left}px !important;
//                                       top: ${top}px !important;
//                                       border: solid blue !important;
//                                       transform: scale(0.5) !important;
//                          `);
//      }
//      })




// var container = document.querySelector('#reactgooglegraph-1 > div:last-child');
// function setPosition () {
//   console.log('set position');
//   var tooltip = container.querySelector('div.google-visualization-tooltip');
//   tooltip.style.top = 0;
//   tooltip.style.left = 0;
// }
// if (typeof MutationObserver === 'function') {
//   console.log('lalallalalallal');
//   var observer = new MutationObserver(function (m) {
//     console.log(m);
//     for (var i = 0; i < m.length; i++) {
//       if (m[i].addedNodes.length) {
//         setPosition();
//         break; // once we find the added node, we shouldn't need to look any further
//       }
//     }
//   });
//   observer.observe(container, {
//     childList: true
//   });
// }
// else if (document.addEventListener) {
//   console.log('lala--');
//   container.addEventListener('DOMNodeInserted', setPosition);
// }
// else {
//   console.log("--lala");
//   container.attachEvent('onDOMNodeInserted', setPosition);
// }
//   }

//document.getElementById('elementID').click();

//var tooltip = container.querySelector('.google-visualization-tooltip');
//console.log(tooltip);
// if(tooltip){
//      var top = parseFloat(tooltip.style.top)/2
//      var left = parseFloat(tooltip.style.left)/2
//      tooltip.setAttribute("style", `left:${left}px !important;
//                                     top: ${top}px !important;
//                                     border: solid blue !important;
//                                     transform: scale(0.5) !important;
//                        `);
//    }






//var hoveredElement = null;
//hoveredElement = e.target;
//console.log(e.target);
// const chart = chartWrapper.getChart()
//if(tooltip){
//  setTimeout(function () {
//    var top = parseFloat(tooltip.style.top)/2
//    var left = parseFloat(tooltip.style.left)/2
//    tooltip.setAttribute("style", `left:${left}px;
//                                   top: ${top}px;
//                                   border: solid blue;
//                                  transform: scale(0.5) !important;
//                      `);
// $(".google-visualization-tooltip").fadeIn(200);
//  }, 1);

//}
//}
// const selection = chart.getSelection()
// if (selection.length === 0) return;
// this.getRegion(map_data[selection[0].row + 1][0])

// getChartEvent = () => {
//     return [
//       {
//         eventName: 'regionClick',
//         callback: (Chart) => {
//           this.props.onRegionClick(Chart.region)
//         },
//       },
//     ]
//   }

// getRegion(country){
//   alert(countryRegion['Russia'])
//   this.setState({ region: 'AU'})
// }

// if(countries.length > 6){
//   if(gender.length >= 2 && (gender.includes('Female') || gender.includes('female'))) {
//     data.forEach( data => {
//       if(data.gender.toLowerCase() === 'female'
//         && data.sample_year == latest_year_country[data.country]
//         && data.age == sortedAgeByData[0]
//         && countries.includes(data.country)){
//           map_data.push([ data.country,
//                           parseFloat(data.value),
//                           `value: ${parseFloat(data.value)}
//                            year: ${data.sample_year}
//                            gender: ${data.gender}
//                            age: ${data.age}` ])
//         }
//       })
//   } else {
//     data.forEach( data => {
//       if(data.gender === gender[0]
//         && data.sample_year == latest_year_country[data.country]
//         && data.age == sortedAgeByData[0]
//         && countries.includes(data.country)){
//           map_data.push([ data.country,
//                           parseFloat(data.value),
//                           `value: ${parseFloat(data.value)}
//                            year: ${data.sample_year}
//                            gender: ${data.gender}
//                            age: ${data.age}` ])
//         }
//       })
//   }
// } else {
//   if(gender.length >= 2 ){
//     data.forEach( data => {
//       if(data.gender.toLowerCase() === 'female' && latest_year_country[data.country] && data.age == sortedAgeByData[0] && countries.includes(data.country)){
//         map_data.push([ data.country, parseFloat(data.value), `value: ${parseFloat(data.value)}
//                                                                year: ${data.sample_year}
//                                                                gender: ${data.gender}
//                                                                age: ${data.age}` ])
//       }
//     })
//   } else if(gender.length === 1 && age.length >= 2){
//     data.forEach( data => {
//       if(data.gender === gender[0] && latest_year_country[data.country] && data.age == sortedAgeByData[0] && countries.includes(data.country)){
//         map_data.push([ data.country, parseFloat(data.value), `value: ${parseFloat(data.value)}
//                                                                year: ${data.sample_year}
//                                                                gender: ${data.gender}
//                                                                age: ${data.age}` ])
//       }
//     })
//   } else {
//     data.forEach( data => {
//       if(data.gender === gender[0] && data.sample_year == latest_year_country[data.country] && data.age == sortedAgeByData[0] && countries.includes(data.country)){
//         map_data.push([ data.country, parseFloat(data.value), `value: ${parseFloat(data.value)}
//                                                                year: ${data.sample_year}
//                                                                gender: ${data.gender}
//                                                                age: ${data.age}` ])
//       }
//     })
//   }
// }



// WEBPACK FOOTER //
// ./src/components/MapView.js